import { Chip, Paper, TextField } from "@material-ui/core";
import Autocomplete from "@mui/material/Autocomplete";
import React, { useEffect, useRef, useState } from "react";
import { isArray, isString } from "lodash";
import toastError from "../../errors/toastError";
import api from "../../services/api";

export function TagsContainer({ contact }) {

    const [tags, setTags] = useState([]);
    const [selecteds, setSelecteds] = useState([]);
    const isMounted = useRef(true);

    useEffect(() => {
        return () => {
            isMounted.current = false
        }
    }, [])

    // Carregar tags sempre que o componente montar
    useEffect(() => {
        if (isMounted.current) {
            loadTags();
        }
    }, []);

    // Atualizar tags selecionadas quando o contact mudar
    useEffect(() => {
        if (isMounted.current && contact) {
            if (Array.isArray(contact.tags)) {
                setSelecteds(contact.tags);
            } else {
                setSelecteds([]);
            }
        }
    }, [contact]);

    const createTag = async (data) => {
        try {
            const { data: responseData } = await api.post(`/tags`, data);
            return responseData;
        } catch (err) {
            toastError(err);
        }
    }

    const loadTags = async () => {
        try {
            console.log('[TagsContainer] Carregando tags do sistema...');
            const { data } = await api.get(`/tags/list`, {
                params: { kanban: 0 }
            });
            console.log('[TagsContainer] Tags carregadas:', data?.length || 0, 'tags');
            console.log('[TagsContainer] Estrutura da primeira tag:', data?.[0]);
            if (isMounted.current) {
                const tagsArray = Array.isArray(data) ? data : [];
                console.log('[TagsContainer] Definindo', tagsArray.length, 'tags no estado');
                setTags(tagsArray);
            }
        } catch (err) {
            console.error('[TagsContainer] Erro ao carregar tags:', err);
            console.error('[TagsContainer] Erro response:', err.response?.data);
            if (isMounted.current) {
                setTags([]);
            }
            toastError(err);
        }
    }

    const syncTags = async (data) => {
        try {
            const { data: responseData } = await api.post(`/tags/sync`, data);
            return responseData;
        } catch (err) {
            toastError(err);
        }
    }

    const onChange = async (value, reason) => {
        if (!contact || !contact.id) {
            console.warn('[TagsContainer] Contact ou contact.id não disponível para sincronizar tags');
            return;
        }

        let optionsChanged = []
        if (reason === 'create-option') {
            if (isArray(value)) {
                for (let item of value) {
                    if (item.length < 3) {
                        toastError("Tag muito curta!");
                        return;
                    }
                    if (isString(item)) {
                        const newTag = await createTag({ name: item, kanban: 0, color: getRandomHexColor() })
                        if (newTag) {
                            optionsChanged.push(newTag);
                        }
                    } else {
                        optionsChanged.push(item);
                    }
                }
            }
            await loadTags();
        } else {
            optionsChanged = value;
        }
        
        if (isMounted.current) {
            setSelecteds(optionsChanged);
        }
        
        try {
            await syncTags({ contactId: contact.id, tags: optionsChanged });
        } catch (err) {
            console.error('[TagsContainer] Erro ao sincronizar tags:', err);
            toastError(err);
        }
    }

    function getRandomHexColor() {
        // Gerar valores aleatórios para os componentes de cor
        const red = Math.floor(Math.random() * 256); // Valor entre 0 e 255
        const green = Math.floor(Math.random() * 256); // Valor entre 0 e 255
        const blue = Math.floor(Math.random() * 256); // Valor entre 0 e 255
      
        // Converter os componentes de cor em uma cor hexadecimal
        const hexColor = `#${red.toString(16).padStart(2, '0')}${green.toString(16).padStart(2, '0')}${blue.toString(16).padStart(2, '0')}`;
      
        return hexColor;
    }

    console.log('[TagsContainer] Renderizando com', tags?.length || 0, 'tags disponíveis e', selecteds?.length || 0, 'tags selecionadas');

    return (
        <Paper style={{ padding: 2 }}>
            <Autocomplete
                multiple
                size="small"
                options={tags || []}
                value={selecteds || []}
                freeSolo
                onChange={(e, v, r) => onChange(v, r)}
                onOpen={() => {
                    console.log('[TagsContainer] onOpen chamado - tags disponíveis:', tags?.length || 0);
                }}
                onClose={() => {
                    console.log('[TagsContainer] onClose chamado');
                }}
                getOptionLabel={(option) => {
                    if (typeof option === 'string') {
                        return option;
                    }
                    return option?.name || '';
                }}
                isOptionEqualToValue={(option, value) => {
                    if (typeof option === 'string' && typeof value === 'string') {
                        return option === value;
                    }
                    if (typeof option === 'object' && typeof value === 'object' && option && value) {
                        return option?.id === value?.id;
                    }
                    return false;
                }}
                renderOption={(props, option) => {
                    const tagName = typeof option === 'string' ? option : (option?.name || '');
                    const tagId = typeof option === 'string' ? option : (option?.id || tagName);
                    return (
                        <li {...props} key={tagId}>
                            <span>{tagName}</span>
                        </li>
                    );
                }}
                filterOptions={(options, state) => {
                    const { inputValue } = state;
                    // Se não há input, mostrar todas as opções
                    if (!inputValue || inputValue.trim() === '') {
                        console.log('[TagsContainer] filterOptions - Mostrando todas as opções:', (options || []).length);
                        return options || [];
                    }
                    const searchValue = inputValue.toLowerCase().trim();
                    const filtered = (options || []).filter((option) => {
                        const name = typeof option === 'string' ? option : (option?.name || '');
                        return name.toLowerCase().includes(searchValue);
                    });
                    console.log('[TagsContainer] filterOptions - Filtrando:', filtered.length, 'de', (options || []).length);
                    return filtered;
                }}
                noOptionsText="Nenhuma tag encontrada"
                renderTags={(value, getTagProps) =>
                    (value || []).map((option, index) => {
                        const tagName = typeof option === 'string' ? option : (option?.name || '');
                        const tagColor = typeof option === 'string' ? '#eee' : (option?.color || '#eee');
                        
                        return (
                            <Chip
                                key={index}
                                variant="outlined"
                                style={{
                                    backgroundColor: tagColor,
                                    color: "#FFF",
                                    marginRight: 1,
                                    padding: 1,
                                    fontWeight: 'bold',
                                    paddingLeft: 5,
                                    paddingRight: 5,
                                    borderRadius: 3,
                                    fontSize: "0.8em",
                                    whiteSpace: "nowrap"
                                }}
                                label={tagName}
                                {...getTagProps({ index })}
                                size="small"
                            />
                        );
                    })
                }
                renderInput={(params) => (
                    <TextField {...params} variant="outlined" placeholder="Tags" />
                )}
                openOnFocus
                autoHighlight
                disableCloseOnSelect
                clearOnBlur={false}
                componentsProps={{
                    popper: {
                        style: {
                            zIndex: 13000
                        },
                        placement: 'bottom-start',
                        disablePortal: false
                    },
                    paper: {
                        style: {
                            zIndex: 13000,
                            textAlign: 'left',
                            maxHeight: 300,
                            overflow: 'auto'
                        }
                    }
                }}
                ListboxProps={{
                    style: {
                        maxHeight: 300,
                        overflow: 'auto'
                    }
                }}
            />
        </Paper>
    )
}